import Phaser from 'phaser';
import ScreenContainer from '../display/ui/ScreenContainer';
import HowToPlayPanel from '../ui/howtoplay/HowToPlayPanel';
import Hud from 'app/ui/hud/Hud';

export default class HowToPlay extends Phaser.State {
  preload() {}

  create() {
    this.container = new ScreenContainer(this.game, {
      title: this.game.copy.getCopy('howtoplay'),
      background: 'background_generic',
    });
    this.game.add.existing(this.container);

    // create and add the hud
    this.hud = new Hud(this.game, Hud.HOWTOPLAY);
    this.game.add.existing(this.hud);

    // grab all the instruction copy
    this.instructions = this.game.copy.getHowToPlayCopy();
    // create the instruction group container to house them all in
    this.instructionContainer = this.game.make.group();
    this.instructions.forEach((instruction, index) => {
      // create an instruction panel for each group
      this.createInstructionPanel(instruction, index, this.instructionContainer);
    });

    this.container.add(this.instructionContainer);

    // set instrction active to 0
    this.instructionIndex = 0;

    // the back button in suitcase is dependant on what state triggered it
    // the return state is passed through for us to utilise
    // the back button in the hud has a custom id to handle the extra logic
    this.hud.onButtonSelect.add(this.handleHudButton, this);
    // we look up prev/next buttons often so may as well grab them now
    this.btnNext = this.hud.getButton('nextpage');
    this.btnPrev = this.hud.getButton('prevpage');
    this.updateCycleButtons();
  }

  // This state uses some 'custom functionality' but utilises the hud for default buttons
  // handle the callback basedon button id
  handleHudButton(btnid, btn) {
    switch (btnid) {
      case 'suitcaseback':
        this.handleBackButton();
        break;
      case 'nextpage':
        this.handleNextState();
        break;
      case 'prevpage':
        this.handlePrevState();
        break;
    }
  }

  handlePrevState() {
    this.instructionIndex = Math.max(0, this.instructionIndex - 1);
    this.updateCycleButtons();
    this.tweenToState();
  }

  handleNextState() {
    this.instructionIndex = Math.min(this.instructionIndex + 1, this.instructions.length - 1);
    this.updateCycleButtons();
    this.tweenToState();
  }

  handleBackButton() {
    this.game.gameController.triggerWelcome();
  }

  updateCycleButtons() {
    const next = this.instructionIndex < this.instructions.length - 1;
    const prev = this.instructionIndex > 0;

    this.btnNext.visible = next;
    this.btnPrev.visible = prev;
  }

  tweenToState() {
    if (this.game.paused) {
      this.instructionContainer.x = -this.game.defaultWidth * this.instructionIndex;
    } else {
      if (this.tween) {
        this.tween.stop();
      }
      this.tween = this.game.add
        .tween(this.instructionContainer)
        .to(
          { x: -(this.game.defaultWidth * this.instructionIndex) },
          500,
          Phaser.Easing.Quadratic.Out,
          true
        );
    }
  }

  createScreenButton(up, over, callback) {
    return;
  }

  createInstructionPanel(instruction, index, container) {
    const panel = new HowToPlayPanel(this.game, {
      title: instruction.title,
      copy: instruction.copy,
      image: 'instruction_' + (index + 1),
    });
    panel.x = this.game.defaultWidth / 2 - panel.width / 2 + this.game.defaultWidth * index;
    panel.y = this.game.defaultHeight / 2 - panel.height / 2 + 50;
    container.add(panel);
  }

  shutdown() {}
}



// WEBPACK FOOTER //
// ./js/app/states/HowToPlay.js